export const getSelectedYears = (years, mapeoType) => {
  const data = []
  if (mapeoType === 'showingFoldersArchivo') {
    years.forEach(year => {
      if (year.selected) {
        data.push(year.value)
      }
    })
  } else {
    data.push(new Date().getFullYear())
  }
  return data
}

export const sortKMLFeaturesByArea = data => {
  const newDataHa = []
  const newDataM2 = []

  data.forEach(feature => {
    const unit = feature.properties.area.split(' ')[1]
    if (unit === 'ha') {
      newDataHa.push(feature)
    }
    if (unit === 'm²') {
      newDataM2.push(feature)
    }
  })

  newDataHa.sort((a, b) => {
    const aArea = parseFloat(a.properties.area.split(' ')[0])
    const bArea = parseFloat(b.properties.area.split(' ')[0])
    return bArea - aArea
  })

  newDataM2.sort((a, b) => {
    const aArea = parseFloat(a.properties.area.split(' ')[0])
    const bArea = parseFloat(b.properties.area.split(' ')[0])
    return bArea - aArea
  })

  const newData = newDataHa.concat(newDataM2)

  return newData
}
